import React from 'react';

import './about.css'

export class AboutComponent extends React.Component {
  render() {
    return <div className="section hs-purple-slides">
              <div className="layout-row hide-xs">
                <div className="flex-50 layout-row layout-align-center-center hs-usage-container">
                  <img id="hs-usage-1" src='/assets/light_sync_app_1.jpg' className={"mdl-shadow--8dp hs-usage-image-large-1 "
                                                                                  + (this.props.aboutLoaded || this.props.aboutLoading ? 'hs-usage-img-loading':'')
                                                                                  + (this.props.aboutLoaded ? ' hs-usage-img-loaded':'')}></img>
                  <img id="hs-usage-2" src='/assets/light_sync_app_2.jpg' className={" mdl-shadow--8dp hs-usage-image-large-2 "
                                                                                  + (this.props.aboutLoaded || this.props.aboutLoading ? 'hs-usage-img-loading':'')
                                                                                  + (this.props.aboutLoaded ? ' hs-usage-img-loaded':'')}></img>
                  <img id="hs-usage-3" src='/assets/light_sync_app_3.jpg' className={" mdl-shadow--8dp hs-usage-image-large-3 "
                                                                                  + (this.props.aboutLoaded || this.props.aboutLoading ? 'hs-usage-img-loading':'')
                                                                                  + (this.props.aboutLoaded ? ' hs-usage-img-loaded':'')}></img>
                  <div className="flex-30"></div>
                </div>
                <div className="flex-50 hs-about-text-container">
                  <div id="hs-editor"></div>
                 </div>
              </div>
              <div className="hide-gt-xs">
                <img src='/assets/usage_mobile.jpg' className="hs-usage-image-small"></img>
                <div className="hs-about-text-container">
                  <p>
                    Synchronise Philips Hue lights with computer display.
                    This is an experimental hobby project. I am in no way affiliated with the Philips organization.
                  </p>
                  <p>
                    The app is based on Electron JS which runs a Python script compiled with Pyinstaller.
                    Runs on Linux, Mac and Windows.
                  </p>
                  <p>
                    <b>Requirements:</b> Existing setup of Philips Hue Lights with a Philips Hue Bridge.
                  </p>
                </div>
              </div>
              
            </div>
        }
}


// WEBPACK FOOTER //
// ./src/components/about.js